import { readUsers } from "@directus/sdk";
import { Select as ChakraSelect, Props } from "chakra-react-select";
import { apiClient, GetEntityListOptions } from "helpers/utils";
import { sortBy, uniqBy } from "lodash";
import debounce from "lodash/debounce";
import { useState } from "react";

interface AutoSuggestInputProps
  extends Pick<GetEntityListOptions, "filter">,
    Omit<Props, "options" | "onInputChange" | "value"> {
  value?: string;
}

export default function AutoSuggestInput({
  filter,
  ...rest
}: AutoSuggestInputProps) {
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );

  const debouncedGetEntityList = debounce((value) => {
    if (!value) return;

    apiClient
      .request(
        readUsers({
          search: value,
          fields: ["id", "first_name", "last_name", "email"],
        })
      )
      .then((result) => {
        setOptions((current) =>
          sortBy(
            uniqBy(
              [
                ...current,
                ...(result ?? []).map((item) => ({
                  label: `${item["first_name"]} ${item["last_name"]}`,
                  value: String(item["id"]),
                })),
              ],
              "value"
            ),
            "label"
          )
        );
      });
  }, 1000);

  return (
    <ChakraSelect
      {...rest}
      placeholder="-- Type for suggestions --"
      onInputChange={(value) => debouncedGetEntityList(value)}
      options={options}
      value={options.find((option) => option.value === rest.value)}
    />
  );
}
